import { render, staticRenderFns } from "./NewJournal.vue?vue&type=template&id=761191e2"
import script from "./NewJournal.vue?vue&type=script&lang=js"
export * from "./NewJournal.vue?vue&type=script&lang=js"
import style0 from "./NewJournal.vue?vue&type=style&index=0&id=761191e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports